module.exports = __webpack_public_path__ + "vuePostit.svg?1709e0e6c5ace5b8567a1b9c0f6620e6";